import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)

// create another store called locations and import data from locations.json
const locations = new Vuex.Store({
  state: {
    locations: []
  },
  mutations: {
    SET_LOCATIONS (state, data) {
      state.locations = data
    }
  },
  getters: {
    locations (state) {
      return state.locations
    }
  }
})
import locationsData from './../locations.json'
locations.commit('SET_LOCATIONS', locationsData)
// show locations in console
//console.log('Loaded locations:', locations.getters.locations)
// import locations from "../../../../locationStore";
// locations.getters.locations.locations[0]['key']
export default locations;
